export default __webpack_public_path__ + "static/media/useLocationIcon.5c0af176.svg";